import { createSlice } from "@reduxjs/toolkit";

// Load initial state from sessionStorage
const userFromStorage = JSON.parse(sessionStorage.getItem("user"));
const isAuthenticatedFromStorage = Boolean(
  sessionStorage.getItem("isAuthenticated")
);

const initialState = {
  user: userFromStorage || null,
  isAuthenticated: isAuthenticatedFromStorage || false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action) => {
      state.user = action.payload.user;
      state.isAuthenticated = true;
      // Save to sessionStorage
      sessionStorage.setItem("user", JSON.stringify(state.user));
      sessionStorage.setItem("isAuthenticated", "true");
    },
    logout: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      // Clear sessionStorage
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("isAuthenticated");
      sessionStorage.removeItem("accessToken");
      const channel = new BroadcastChannel('auth');
      channel.postMessage('logout');
      channel.close();
    },
  },
});

export const { login, logout } = authSlice.actions;
export default authSlice.reducer;
